import { apiClient } from '@/lib/api.ts'

export function testAlsoConnection() {
  return apiClient.post('/also/test-connection', {})
}
